import { Behaviourable, BehaviourConfig } from '../../managers/ScrollBehaviourManager';
import { ScrollerType } from 'app/data/Enums';
import { device } from 'utils/device';

/** @class Scroll behaviour class, triggers when a region is viewable */
export class RegionBehaviour implements Behaviourable {
	//Protected  ------------------------------------------
	protected _region: HTMLElement;
	protected _regionRect: DOMRect;
	protected _regionHeight: number;
	protected _regionOffsetTop: number;
	protected _viewable: boolean = true;
	protected _innerHeight: number = 0;
	protected _scrollY: number = 0;
	//Private -----------------------------------------------
	private _viewableTolerence: number = 500; //+/- When a region is consiedered visible:

	constructor(
		protected _config: BehaviourConfig,
		protected _container: HTMLElement
	) {
		this._region = _container.querySelector(`#${this._config.id}`);

		if (!this._testValidRegion()) {
			this.destroy();
		}
	}

	public destroy(): void {
		this._config = null;
		this._container = null;
		this._regionRect = null;
		this._region.removeEventListener('resize', this.resize.bind(this));
	}

	public resize(): void {
		if (!this._config) {
			return;
		}

		this._innerHeight = device.innerHeight;
		this._regionRect = this._region.getBoundingClientRect() as DOMRect;
		this._regionHeight = this._region.clientHeight;
		this._regionOffsetTop = this._region.offsetTop;
	}

	public update(scroll: number): void {
		this._scrollY = scroll;
		this._testInViewport();
	}

	//private
	//-----------------------------------------------------------------------------------------

	/** Test if the region is in in viewport (allowing for any tolerences). Can be used for lazy loading, video play/stoping, resting state, hiding, etc */
	private _testInViewport(): void {
		if (this._viewable !== this._checkRegionInViewPort()) {
			this._viewable = !this._viewable;

			//If is setup to hide when outside view viewport then css hide / show
			if (this._config.hideOutsideViewport && this._config.scrollerType === ScrollerType.CUSTOM) {
			}
		}
	}

	/** Measure if region is in Viewport
	 * @return {boolean}
	 */
	private _checkRegionInViewPort(): boolean {
		if (
			this._scrollY + this._innerHeight > this._regionOffsetTop - this._viewableTolerence &&
			this._scrollY < this._regionOffsetTop + this._regionHeight + this._viewableTolerence
		) {
			return true;
		}


		return false;
	}

	/** Test if the region is actualy valid. Throw an error if not
	 * @return {boolean}
	 */
	private _testValidRegion(): boolean {
		if (!this._region) {
			try {
				throw new Error(`Behaviour region not valid target  : ${JSON.stringify(this._config)}`);
			} catch (e) {
				console.log(e);
			}
			return false;
		}

		return true;
	}
}
